/**
 * Normalize text for Select option search: trim, lowercase, strip diacritics.
 */
export const normalizeSearchText = (value: unknown): string => {
  if (value == null) {
    return '';
  }

  return String(value)
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
};

type SelectFilterOption = {
  children?: unknown;
  label?: unknown;
  value?: unknown;
};

/**
 * Ant Design Select `filterOption` that matches case- and accent-insensitively
 * against option label/children/value (e.g. "Origen" ↔ "Orígen" / "origen").
 */
export const filterSelectOption = (input: string, option?: SelectFilterOption): boolean => {
  const normalizedInput = normalizeSearchText(input);
  if (!normalizedInput) {
    return true;
  }

  const labelCandidate = option?.children ?? option?.label ?? option?.value ?? '';
  const labelText =
    typeof labelCandidate === 'string' || typeof labelCandidate === 'number'
      ? String(labelCandidate)
      : String(option?.value ?? '');

  return normalizeSearchText(labelText).includes(normalizedInput);
};
